import { render, staticRenderFns } from "./appEduCourses.vue?vue&type=template&id=b721f300&scoped=true"
import script from "./appEduCourses.vue?vue&type=script&lang=js"
export * from "./appEduCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b721f300",
  null
  
)

export default component.exports